<div>
  @if (configurationLeadTime()) {
    <span class="leadTimeSpan">
      <label>Lead Time:</label>
      <label [class.validLeadTime]="validLeadTime" [class.invalidLeadTime]="!validLeadTime">
        {{ configurationLeadTime().code }}
      </label>
    </span>
  }
  @if (entityLeadTime()) {
    <span class="leadTimeSpan">
      <label>Entity Lead Time:</label>
      <label>{{ entityLeadTime().code }}</label>
    </span>
  }
</div>
